import { useParams } from 'react-router';
import { useGetDealerQuery } from '../../../api/queries/getDealer';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import DealerInner from './DealerInner';

const DealerDetails = () => {
    const { dealerId } = useParams<{ dealerId: string }>();

    const { data, loading } = useGetDealerQuery({
        fetchPolicy: 'network-only',
        variables: { id: dealerId },
    });

    const dealer = data?.getDealer;

    if (!dealer && loading) {
        return <LoadingElement />;
    }

    if (!dealer) {
        return <NotFoundResult />;
    }

    return <DealerInner dealer={dealer} />;
};

export default DealerDetails;
